import facebook from '../assets/images/socials/facebook.png';
import linkedin from '../assets/images/socials/linkedin.png';
import twitter from '../assets/images/socials/twitter.png';

export const footericons = [
  {
    img: facebook,
    url: 'https:/www.facebook.com',
  },
  {
    img: twitter,
    url: 'https:/www.twitter.com',
  },

  {
    img: linkedin,
    url: 'https:/www.instagram.com',
  },
];
